var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("推广时间："+_vm._s(_vm.row?.promotionStartTime)+" 至 "+_vm._s(_vm.row?.promotionEndTime))]),_c('div',[_vm._v("活动名称："+_vm._s(_vm.row?.activityName || '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }